import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
export default {
  props: {
    monthDates: {
      type: Array,
      default: () => []
    },
    courses: {
      type: Object,
      default: () => ({})
    },
    schedules: {
      type: Array,
      default: () => []
    },
    courseColor: {
      type: Object,
      default: () => ({})
    },
    todayDate: {
      type: String,
      default: ""
    }
  },
  emits: ["edit-schedule"],
  computed: {
    weeks() {
      const ret = [];
      for (let i = 0; i < this.monthDates.length; i += 7) ret.push(this.monthDates.slice(i, i + 7));
      return ret;
    },
    periods() {
      const values = new Set();
      Object.values(this.courses || {}).forEach(day => Object.keys(day || {}).forEach(p => values.add(p)));
      (this.schedules || []).forEach(item => values.add(item.period));
      return [...values].sort();
    }
  },
  methods: {
    courseAt(date, period) {
      return this.courses[date] && this.courses[date][period];
    },
    scheduleAt(date, period) {
      return this.schedules.find(item => String(item.date).slice(0, 10) === date && item.period === period);
    },
    colorFor(course) {
      return this.courseColor[course] || "#1743a3";
    },
    lightColorFor(course) {
      const color = this.colorFor(course);
      const hex = color.replace("#", "");
      if (!/^[0-9a-fA-F]{6}$/.test(hex)) return "#eef3ff";
      const rgb = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16));
      return `rgb(${rgb.map(v => Math.round(v + (255 - v) * .88)).join(",")})`;
    }
  }
};